import produce from 'immer';

const initialState = {
  createdBy: 'abcd',
};

const CreateQuoteReduxState = (currentState = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_CREATED_BY': {
      return produce(currentState, (draftState) => {
        draftState.createdBy = action.createdBy;
      });
    }
    case 'INITIALIZE_STATE':
      return initialState;

    default:
      return currentState;
  }
};

export default CreateQuoteReduxState;
